// @flow
import React from "react"
import { compose, withStateHandlers, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import { selectAllProductGroups } from "data/app/selectors"
import type { ProductGroup } from "data/app/types"
import FilterToggle from "./FilterToggle"
import { CategorySelectorWrap, ProductCategoryContent } from "./styled"

const ProductCategorySelector = ({
  allProductGroups,
  onSelect,
  clear,
  selectedProductCategory,
}) => {
  return (
    <React.Fragment>
      <ProductCategoryContent>
        <CategorySelectorWrap>
          {(allProductGroups || []).map(productGroup => {
            const selected = productGroup.name === selectedProductCategory
            return (
              <FilterToggle
                key={productGroup.id}
                value={productGroup}
                selected={selected}
                formatter={(pg: ProductGroup) => pg.name}
                onClick={onSelect}
              />
            )
          })}
        </CategorySelectorWrap>
      </ProductCategoryContent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  allProductGroups: selectAllProductGroups(state),
})

type Outter = {|
  /** Callback upon selection of a value in the product group filter */
  handleSelect: (productCategory: ProductGroup[]) => any,
|}

const enhancer: HOC<*, Outter> = compose(
  withConnect(mapStateToProps),
  withStateHandlers(
    props => ({
      selectedProductCategory: "",
    }),
    {
      onSelect: (state, props) => productCategory => {
        props.handleSelect(productCategory)
        return {
          selectedProductCategory: productCategory.name,
        }
      },
      clear: (state, props) => () => {
        return {
          selectedProductCategory: "",
        }
      },
    },
  ),
)

export default enhancer(ProductCategorySelector)



// WEBPACK FOOTER //
// ./src/components/ProductCategorySelector/index.js